export default __webpack_public_path__ + "static/media/cs-logo-red-sky.2d063f9a.svg";